<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'汎用テキスト' | translate}}</h1>

  <div class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="openAddDialog()">
      <mat-icon>add</mat-icon>
      <span>{{'追加' | translate}}</span>
    </button>

    <button mat-raised-button color="warn" (click)="deleteData()" [disabled]="!selection.selected.length">
      <mat-icon>delete</mat-icon>
      <span>{{'削除' | translate}}</span>
    </button>
  </div>
</div>

<div fxLayout="column" fxLayoutAlign="center center">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="74"> No. </th>
      <td mat-cell *matCellDef="let generalText; let i = index"> {{ (i + 1) + (paginator.pageSize * paginator.pageIndex) }} </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef> {{'編集' | translate}} </th>
      <td mat-cell *matCellDef="let generalText">
        <button mat-button color="primary" (click)="openEditDialog(generalText)">
          <mat-icon>create</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef> {{'削除' | translate}} </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox color="warn" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="80"> ID </th>
      <td mat-cell *matCellDef="let generalText"> {{ generalText.text_id }} </td>
    </ng-container>

    <ng-container matColumnDef="text">
      <th mat-header-cell *matHeaderCellDef> {{'テキスト' | translate}} </th>
      <td mat-cell *matCellDef="let generalText"> {{ generalText.texts | generalText:projectBaseLang}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[15, 30, 50]" showFirstLastButtons></mat-paginator>
</div>